(function (app) {
    app.factory("toolboxFactory", ["externalLoading", "permissionService", "ssoApi", "userApi",
        function toolboxFactory(externalLoading, permissionService, ssoApi, userApi) {

            var service = {};

            service.getUserPermittedTiles = function () {
                var permittedTiles = [];

                tiles.forEach(function (tile) {
                    if (tile.Permission == null || permissionService.hasAllPermissions(tile.Permission)) {
                        permittedTiles.push(tile);
                    }
                });

                return permittedTiles;
            };

            service.getFeaturedTiles = function () {
                var permittedTiles = service.getUserPermittedTiles();
                var featuredTiles = [];
                permittedTiles.forEach(function (tile) { if (tile.IsFeatured) featuredTiles = featuredTiles.concat(tile); })
                return featuredTiles;
            }

            service.getUserFavorites = function (userId) {
                var permittedTiles = service.getUserPermittedTiles();
                var favoriteTiles = [];

                return userApi.getUserToolboxFavorites(userId)
                    .then(function (result) {
                        permittedTiles.forEach(function (tile) {
                            tile.IsFavorite = result.some(function (favorite) {
                                if (tile.Id == null) return false;
                                return favorite.replace(/[{}]/g, "").toLowerCase() === tile.Id.replace(/[{}]/g, "").toLowerCase();
                            });
                            if (tile.IsFavorite) favoriteTiles = favoriteTiles.concat(tile);
                        });
                        return favoriteTiles;
                    })
            };

            service.getCategories = function () {
                return categories;
            }

            service.getAllTiles = function () {
                return tiles;
            };



            var classes = { Purple: "text-purple", Blue: "text-blue", Pink: "text-pink", Green: "text-green" };
            var icons = { Document: "fig-document-sign", Coin: "fig-coin", Calculator: "fig-calculator", School: "fig-school" };
            //var categories = { Calculators: "calculators", Forms: "forms", Quotes: "quotes", Tutorials: "tutorials" };
            var categories = [
                {
                    Name: 'forms',
                    Description: 'Collection of downloadable and submittable forms',
                    Class: 'text-green',
                    Icon: icons.Document,
                    Selected: false
                },
                {
                    Name: 'quotes',
                    Description: 'Find and run quotes on different platforms',
                    Class: 'text-pink',
                    Icon: icons.Coin,
                    Selected: false
                },
                {
                    Name: 'calculators',
                    Description: 'Financial planing and retirement tools',
                    Class: 'text-blue',
                    Icon: icons.Calculator,
                    Selected: false
                },
                {
                    Name: 'tutorials',
                    Description: 'Learn about insurance products with these resources',
                    Class: 'text-purple',
                    Icon: icons.School,
                    Selected: false
                },
            ];
            var tiles = [
                //FORMS
                {
                    Id: "e836d534-8558-45df-83be-52e7c84374e9",
                    Name: "Annuity Forms Wizard",
                    ShortDescription: "Quick access to up-to-date annuity form packets.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Annuity"],
                    Act: function () {
                        if (permissionService.hasOnePermission("IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateIpipelineSso("forms").then(function (data) {
                                w.document.write(data);
                                w.document.forms.samlform.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "IpipelineFormsQuotesAnnuity:Access|AnnuityFormsWizard:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "e9d34063-14d3-4e3f-8a96-a337926f738c",
                    Name: "RetireUp Pro",
                    ShortDescription: "An online platform for personalized retirement planning.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "RetireUp Pro", "Retire Up Pro"],
                    Act: function () {
                        alert("Not implemented yet!");
                    },
                    Permission: null,
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: true,
                    Order: 2,
                    ImgUrl: 'https://images.unsplash.com/photo-1533444273691-ebf51af8fd9c?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8cmV0aXJlbWVudHxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                },
                {
                    Id: "196ec350-038c-4303-b3f7-7c166775f62a",
                    Name: "Annuity Rate Watch",
                    ShortDescription: "An extensive rate comparison tool for annuity products.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Annuity"],
                    Act: function () {
                        if (permissionService.hasOnePermission("AnnuityRateWatch:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateAnnuityRateWatchSso().then(function (data) {
                                w.location = JSON.parse(data.Result);
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "IpipelineFormsQuotesAnnuity:Access|AnnuityFormsWizard:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: true,
                    Order: 1,
                    ImgUrl: 'https://images.unsplash.com/photo-1520632461690-67205b04e73d?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTV8fGxpZmV8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                },
                {
                    Id: "115a41bb-654f-4b74-8d64-a8119180b70b",
                    Name: "ASCM Signature Guarantee Agreement",
                    ShortDescription: "Download the Alphastar Medallion Signature Guarantee Agreement.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Annuity"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/ASCM_Signature_Guarantee_Agreement.pdf");
                    },
                    Permission: "AscmMedallionAgreement:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "f6d1af6a-b915-4fb6-9691-9c4b27f12504",
                    Name: "ASCM Signature Guarantee Guide",
                    ShortDescription: "Download the Alphastar Medallion Signature Guarantee Guide.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Annuity"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/ASCM_Signature_Guarantee_Guide.pdf");
                    },
                    Permission: "AscmMedallionGuide:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "4f93707e-e0fe-4faf-bbb9-034ae2dbf939",
                    Name: "Life Forms Wizard",
                    ShortDescription: "Quick access to up-to-date life form packets.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Life"],
                    Act: function () {
                        if (permissionService.hasOnePermission("IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateIpipelineSso("forms").then(function (data) {
                                w.document.write(data);
                                w.document.forms.samlform.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "IpipelineFormsQuotesLife:Access|LifeFormsWizard:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "4ad2eb64-6bfd-428c-9e43-55442223f653",
                    Name: "HIPAA Form",
                    ShortDescription: "Download FIG’s HIPAA form.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Life"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/FIG_HIPAA_9-2017.pdf");
                    },
                    Permission: "HipaaForm:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "604a987d-6014-4078-afe7-7f375ba8084d",
                    Name: "Life Application Process",
                    ShortDescription: "Walk through our application process for life.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Life"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/Life_Application_Process.pdf")
                    },
                    Permission: "LifeApplicationProcess:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "ca665c03-d696-4210-8e1d-a8d6075d418a",
                    Name: "Care Planning Forms Wizard",
                    ShortDescription: "Quick access to up-to-date Care Planning form packets.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Care Planning", "LTC", "Long Term Care"],
                    Act: function () {
                        if (permissionService.hasOnePermission("IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateIpipelineSso("forms").then(function (data) {
                                w.document.write(data);
                                w.document.forms.samlform.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "IpipelineFormsQuotesLtc:Access|LtcFormsWizard:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "04c7df60-bbc3-464b-993e-5190add96143",
                    Name: "Care Planning Liability Release Form'",
                    ShortDescription: "Download the Care Planning Liability Release Form.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Care Planning", "LTC", "Long Term Care"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/LTC-Liabilty-Form.pdf");
                    },
                    Permission: "LtcLiabilityReleaseForm:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "fe83f194-d0e6-40ed-9dcf-79f847711391",
                    Name: "Care Planning Prequalification Form",
                    ShortDescription: "Return to FIG to get carrier underwriter feedback before taking an application.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Care Planning", "LTC", "Long Term Care"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/2019_Team_Prequalification_Questionnaire.pdf");
                    },
                    Permission: "LtcLiabilityReleaseForm:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "408a04a9-2fb5-47aa-8f22-b9e37dda2740",
                    Name: "Asset Identifier",
                    ShortDescription: "Use in conjunction with “3 Steps” Sales Process. Revisit annually.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Care Planning", "LTC", "Long Term Care"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/Asset_Identifier_2018.pdf");
                    },
                    Permission: "LtcLiabilityReleaseForm:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                {
                    Id: "aa8bf0ef-ffbf-4841-9f62-d5c9d94342ad",
                    Name: "Care Planning Pre-Approach Letter",
                    ShortDescription: "Go back to your existing book of business using this product agnostic prospecting letter.",
                    LongDescription: null,
                    Category: categories[0].Name,
                    Tags: [categories[0].Name, "Care Planning", "LTC", "Long Term Care"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/Care_Planning_Pre-Approach_Letter.pdf");
                    },
                    Permission: "LtcLiabilityReleaseForm:View",
                    Class: classes.Green,
                    Icon: icons.Document,
                    IsFeatured: false
                },
                // QUOTES
                {
                    Id: "a4009ea4-2d89-4223-aa64-833fd60aea59",
                    Name: "LTCI Quote Engine",
                    ShortDescription: "Quick side-by-side quoting for standalone LTC products.",
                    LongDescription: null,
                    Category: categories[1].Name,
                    Tags: [categories[1].Name, "Care Planning", "LTC"],
                    Act: function () {
                        window.open("https://www.ltcipartners.com/generate-a-quote-stratecision");
                    },
                    Permission: "LtciPartnersWebsite:View",
                    Class: classes.Pink,
                    Icon: icons.Coin,
                    IsFeatured: false
                },
                {
                    Id: "4bb324e0-c42a-4a15-867a-d1af0c91c81e",
                    Name: "SPIA/DIA Quotes",
                    ShortDescription: "Access to real-time quoting engine for SPIA’s and DIA’s.",
                    LongDescription: null,
                    Category: categories[1].Name,
                    Tags: [categories[1].Name, "Annuity", "SPIA", "DIA"],
                    Act: function () {
                        if (permissionService.hasOnePermission("Cannex:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateCannexSso().then(function (data) {
                                w.document.write(data);
                                w.document.forms.cannex.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "Cannex:Access",
                    Class: classes.Pink,
                    Icon: icons.Coin,
                    IsFeatured: true,
                    Order: 3,
                    ImgUrl: 'https://images.unsplash.com/photo-1561112079-2c3226d9c559?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MzB8fGNhbGN1bGF0b3JzfGVufDB8fDB8&auto=format&fit=crop&w=500&q=60',
                },
                {
                    Id: "1de65e6f-238c-4ea4-ade5-1adafe3ea152",
                    Name: "Annexus Direct Quotes",
                    ShortDescription: "Run quotes on the Annexus platform.",
                    LongDescription: null,
                    Category: categories[1].Name,
                    Tags: [categories[1].Name, "Annuity"],
                    Act: function () {
                        if (permissionService.hasOnePermission("AnnexusQuotes:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateAnnexusSso().then(function (data) {
                                w.document.write(data);
                                w.document.forms.samlform.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "AnnexusQuotes:Access",
                    Class: classes.Pink,
                    Icon: icons.Coin,
                    IsFeatured: false
                },
                {
                    Id: "3c335d5e-cf51-4363-8199-642fa5e723cf",
                    Name: "Ensight",
                    ShortDescription: "Simplify insurance sales with Ensight’s™ stunning visual customer experience.",
                    LongDescription: null,
                    Category: categories[1].Name,
                    Tags: [categories[1].Name, "Life"],
                    Act: function () {
                        var w = window.open();
                        w.document.write(externalLoading.html);
                        ssoApi.initiateEnsightSso().then(function (data) {
                            w.location = data;
                        },
                            function (error) {
                                w.document.write(" Failed.  There was an error accessing this resource.");
                            });
                    },
                    Permission: "Ensight:Access",
                    Class: classes.Pink,
                    Icon: icons.Coin,
                    IsFeatured: false
                },
                {
                    Id: "abd7fba2-7d2f-4e92-a6a4-5488d588fd4a",
                    Name: "Term Life Quote Engine",
                    ShortDescription: "Access to real-time life quoting.",
                    LongDescription: null,
                    Category: categories[1].Name,
                    Tags: [categories[1].Name, "Term Life", "Life"],
                    Act: function () {
                        if (permissionService.hasOnePermission("IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateIpipelineSso("lifeQuotes").then(function (data) {
                                w.document.write(data);
                                w.document.forms.samlform.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "IpipelineFormsQuotesLife:Access|LifeQuoteEngine:View",
                    Class: classes.Pink,
                    Icon: icons.Coin,
                    IsFeatured: true,
                    Order: 4,
                    ImgUrl: 'https://images.unsplash.com/photo-1502651492682-6c7b46d75d85?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTF8fGxpZmV8ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                },
                //TODO: maybe remove
                {
                    Id: "76eeb1b0-8aaa-4d53-bbe4-4a509a363bf9",
                    Name: "ABLTC Quote Request",
                    ShortDescription: "Return to FIG for customized solutions for your clients.",
                    LongDescription: null,
                    Category: categories[1].Name,
                    Tags: [categories[1].Name, "Care Planning", "Long Term Care", "LTC"],
                    Act: function () { 
                        window.open("https://www.figmarketing.com/files/2019_ASSET-BASED_LTC_QUOTE_REQUEST_FORM.pdf");
                    },
                    Permission: "LtcLiabilityReleaseForm:View",
                    Class: classes.Pink,
                    Icon: icons.Coin,
                    IsFeatured: false
                },
                // CALCULATORS
                {
                    Id: "fa4998bb-8950-42af-a4d9-9abeaa7d6f7b",
                    Name: "U.S. 1040EZ Tax Estimator",
                    ShortDescription: "The 1020EZ tool lets you quickly calculate your tax bill compared to the 1040 form.",
                    LongDescription: "Many people can use the 1040EZ tax form instead of the more complicated 1040 to calculate their taxes.Containing only seven required inputs, the 1040EZ is one of the quickest forms to calculate your tax bill.",
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Tax"],
                    Act: function () {
                        window.open("/DinkyTown/TaxEZ1040.html", "dinkytown")
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "fa4998bb-8950-42af-a4d9-9abeaa7d6f7b",
                    Name: "Policy Valuation",
                    ShortDescription: "Get non-mortality based pricing for life policies in the life settlement market. Used for trust valuations, replacement policies and surrender alternatives for maximum value.",
                    LongDescription: "Use this calculator to get a non-mortality based pricing for your client’s life policy in the life settlement market.  Use for trust valuations, replacement policies, and surrender alternatives to get the maximum value for your client.",
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Life"],
                    Act: function () {
                        var w = window.open();
                        w.document.write(externalLoading.html);
                        ssoApi.initiateMapleLifeCalculatorSso().then(function (redirectUrl) {
                            w.location = redirectUrl;
                        });
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "814b38a7-62c3-4ddd-bd3c-70f5b7cf27b4",
                    Name: "Savings Goals",
                    ShortDescription: "What will it take to reach your savings goal? This financial calculator helps you find out.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Savings"],
                    Act: function () {
                        window.open("/DinkyTown/Savings.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "80dd3598-5869-42f8-bf41-f05a7c7eb6ec",
                    Name: "Savings, Taxes, & Inflation",
                    ShortDescription: "Determine how much your savings will be worth with these two important variables in mind.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Savings", "Taxes", "Inflation"],
                    Act: function () {
                        window.open("/DinkyTown/SavingsVariables.html", "dinkytown");
                    },
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    Permission: null,
                    IsFeatured: false
                },
                {
                    Id: "d286ea71-d62b-4a3f-9c1d-068255beed17",
                    Name: "Net Worth",
                    ShortDescription: "Determine your net worth, and how it could grow (or shrink!) over the next ten years.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Finance"],
                    Act: function () {
                        window.open("/DinkyTown/NetWorth.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "f49d50b4-3c7c-4b34-8629-f38c7cf40c4e",
                    Name: "Investment Returns",
                    ShortDescription: "There is more to investing than knowing your annual rate of return. Use this calculator to help you see how inflation, taxes and your time horizon can impact your bottom line.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Investments"],
                    Act: function () {
                        window.open("/DinkyTown/InvestmentReturn.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "bffcfaf0-4338-43c5-8740-43d43068160e",
                    Name: "72(t)",
                    ShortDescription: "The IRS Rule 72T allows for penalty free, early withdrawals from retirement accounts. Use this calculator to determine your allowable 72T Distribution and how it can help fund your early retirement.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/Retire72T.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "112546bd-c193-44ec-86bf-e1771dfbeef6",
                    Name: "Retirement Income",
                    ShortDescription: "Determine how much monthly income your retirement savings may provide you in your retirement.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/RetirementIncome.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "92c8f735-349e-41c1-b1c8-6586fbceb29e",
                    Name: "Retirement Planner",
                    ShortDescription: "Determine if your retirement plan is on track - and learn how to keep it there.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/RetirementPlan.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "b8c63bd3-6293-4dd4-b33b-282596187921",
                    Name: "RMD & Stretch IRA",
                    ShortDescription: "Determine how you can stretch out your retirement plan distributions for as long as possible.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/StretchIRA.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "0e9db232-ea40-4249-ab71-3e52a7c9c43f",
                    Name: "Roth IRA",
                    ShortDescription: "Compare the Roth IRA to an ordinary taxable investment.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/RothIRA.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "6117ed2e-7e1b-456d-96dc-9cd1c81d47cf",
                    Name: "Roth IRA Conversion",
                    ShortDescription: "This calculator will show the advantage, if any, of converting your IRA to a Roth.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/RothTransfer.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "225a3946-8700-4a40-b915-3ba64c2a9c6c",
                    Name: "Roth IRA Conversion with Distributions",
                    ShortDescription: "Determine how you can stretch out your retirement plan distributions for as long as possible.",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/RothConversion.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "9720e085-8fa7-4cb6-8c2b-11c219840d80",
                    Name: "Traditional IRA",
                    ShortDescription: "How can contributing to a regular IRA help you in your retirement?",
                    LongDescription: null,
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Retire", "Retirement"],
                    Act: function () {
                        window.open("/DinkyTown/RegularIRA.html", "dinkytown");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "940d2b94-b521-4e5a-b374-a050b20fee69",
                    Name: "Life Quotes Needs Analysis",
                    ShortDescription: "Determine how much life insurance would be suitable for an individual’s needs.",
                    LongDescription: "This calculator is designed to help determine how much life insurance would be suitable for an individual’s needs. The amount of coverage a company is willing to offer based on its financial underwriting review may not match the amount of coverage determined using a needs analysis calculator.",
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Life"],
                    Act: function () {
                        if (permissionService.hasOnePermission("IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateIpipelineSso("lifeQuotesAnalysis").then(function (data) {
                                w.document.write(data);
                                w.document.forms.samlform.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "IpipelineFormsQuotesLife:Access",
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                {
                    Id: "15e74ae3-7cec-4320-b3b1-9a12c03245cd",
                    Name: "Abacus Life Settlements Calculator",
                    ShortDescription: "Receive a range of estimates for life insurance settlement based on health rankings. Recommended for individuals age 65 and higher",
                    LongDescription: "Use this calculator for a range of estimates for life insurance settlements based on various health rankings. These estimates are focused on age 65 and higher. This calculator is not a substitute for a full life insurance product illustration. Customers should receive a full illustration prior to applying for any life insurance policy. The results this calculator produces is subject to change without notice. This calculator, and the results it produces, should not be construed as an offer to buy, sell, replace or exchange any product. Life insurance policy applications are vetted through an underwriting process set forth by the issuing insurance company. Some applications may not be accepted based upon adverse underwriting results. Premium payments vary by customer and are derived from the results of the underwriting process. Death benefit payouts are backed by the claims paying ability of the issuing insurance company.",
                    Category: categories[2].Name,
                    Tags: [categories[2].Name, "Life"],
                    Act: function () {
                        window.open("https://abacuslifesettlements.com/fig/");
                    },
                    Permission: null,
                    Class: classes.Blue,
                    Icon: icons.Calculator,
                    IsFeatured: false
                },
                // TUTORIALS
                {
                    Id: "56655c66-ab9d-4bbe-9334-ed961395d12c",
                    Name: "LTCI Partners Website",
                    ShortDescription: "Access the LTCI Partners website here.",
                    LongDescription: null,
                    Category: categories[3].Name,
                    Tags: [categories[3].Name, "LTC", "Long Term Care", "Care Planning"],
                    Act: function () {
                        window.open("https://www.ltcipartners.com/");
                    },
                    Permission: "LtciPartnersWebsite:View",
                    Class: classes.Purple,
                    Icon: icons.School,
                    IsFeatured: false
                },
                {
                    Id: "317b48fb-a079-461f-8942-4abef012cae8",
                    Name: "Life Product Search",
                    ShortDescription: "Access to an array of life products.",
                    LongDescription: null,
                    Category: categories[3].Name,
                    Tags: [categories[3].Name, "Life"],
                    Act: function () {
                        if (permissionService.hasOnePermission("IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                            var w = window.open();
                            w.document.write(externalLoading.html);
                            ssoApi.initiateIpipelineSso("lifeProducts").then(function (data) {
                                w.document.write(data);
                                w.document.forms.samlform.submit();
                            },
                                function (error) {
                                    w.document.write(" Failed.  There was an error accessing this resource.");
                                });
                        }
                    },
                    Permission: "IpipelineFormsQuotesLife:Access|LifeProductSearch:View",
                    Class: classes.Purple,
                    Icon: icons.School,
                    IsFeatured: false,
                },
            ];

            return service;
        }
    ])
})(window.app);